import React from 'react';
import { Card, CardContent, Typography, Box, IconButton } from '@mui/material';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import RefreshIcon from '@mui/icons-material/Refresh';

const MetricCard = ({
  title,
  value,
  subtitle,
  icon: Icon,
  trend,
  trendValue,
  color = 'primary',
  onRefresh
}) => {
  const formatValue = (val) => {
    if (typeof val === 'number') {
      if (val >= 1000) {
        return (val / 1000).toFixed(1) + 'k';
      }
      return val.toLocaleString();
    }
    return val;
  };

  const getTrendColor = (trend) => {
    if (trend === 'up') return 'success.main';
    if (trend === 'down') return 'error.main';
    return 'text.secondary';
  };

  const TrendIcon = trend === 'up' ? TrendingUpIcon : trend === 'down' ? TrendingDownIcon : null;

  return (
    <Card sx={{ height: '100%', position: 'relative' }}>
      <CardContent>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
          <Typography variant="subtitle1" color="text.secondary" fontWeight={600}>
            {title}
          </Typography>
          {onRefresh && (
            <IconButton size="small" onClick={onRefresh} sx={{ opacity: 0.7 }}>
              <RefreshIcon fontSize="small" />
            </IconButton>
          )}
        </Box>

        <Typography variant="h2" fontWeight={700} color="text.primary" mb={2}>
          {formatValue(value)}
        </Typography>

        {trend && trendValue && (
          <Box display="flex" justifyContent="flex-end" alignItems="center" gap={0.5}>
            {TrendIcon && (
              <TrendIcon
                fontSize="medium"
                sx={{ color: getTrendColor(trend) }}
              />
            )}
            <Typography
              variant="body2"
              sx={{ color: getTrendColor(trend), fontWeight: 600 }}
            >
              {trendValue}
            </Typography>
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default MetricCard;